import { Criteria } from '@daas-consulting/core-cross-interfaces';
import {
  AuditModel,
  Filter,
} from '@daas-consulting/security/audit/frontend/models';
import { Observable } from 'rxjs';

export interface AuditDetailPageViewContract {
  items$: Observable<AuditModel[]>;
  activeFilters$: Observable<Criteria[]>;
  filter$: Observable<Filter>;
  item$: Observable<AuditModel>;
  loadItemSuccessful$: Observable<void>;
  hasDetail$: Observable<boolean>;
  activeDetail$: Observable<number>;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  detail$: Observable<any>;
  load($event: AuditModel): void;
  loadHistory($event: AuditModel): void;
  loadDetail($event: AuditModel): void;
  reset(): void;
}

export const SecurityAuditDetailPageViewContractId =
  'SecurityAuditDetailPageViewContractId';
